module.exports = __webpack_public_path__ + "img/stage-2.54dd37e5.png";